import classNames from 'classnames'
import * as React from 'react'
import { CartesianGrid as RechartsCartesianGrid } from 'recharts'

export function CartesianGrid({
  vertical = false,
  ...props
}: React.PropsWithoutRef<React.ComponentProps<typeof RechartsCartesianGrid>>) {
  return (
    <RechartsCartesianGrid
      {...props}
      vertical={vertical}
      stroke={null as any} // Types don’t allow null
      strokeDasharray="3 3"
      className={classNames(props.className, 'stroke-gray-100 dark:stroke-gray-700')}
    />
  )
}

CartesianGrid.displayName = RechartsCartesianGrid.displayName
